// extracted by mini-css-extract-plugin
export default {"wrapper":"Jx3qg","container":"y7iJ3","text":"dpdX9","links":"OuyfX","title":"yt2A8","description":"BZceU","link":"geIOz","image":"jMRKq"};